/* global jQuery */
/* global dataLayer */

const $ = jQuery;

$(document).ready(function() {
    // Newsletter
    const newsletterForm = $('footer form');

    newsletterForm.submit(() => {
        dataLayer.push({
            event: 'newsletterSubscribe'
        });
    });

    // Nominationform
    $(document).bind('gform_confirmation_loaded', function() {
        dataLayer.push({
            event: 'submitNomination'
        });
    });

    // Nomination form interaction
    $('.nominate form[action*="nominate"] :input').on('change', function() {
        if(!window.nominationFormInteraction) {
            dataLayer.push({
                event: 'nominationForm'
            });
            window.nominationFormInteraction = true
        }
    })
});
